import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Navbar, NavLink, NavDropdown, Nav } from "react-bootstrap";
import PdfLesson from "../Components/PdfLesson/PdfLesson";
import { useModuleContext } from "../Context/ModuleContext";
import { useAuth } from "../Context/AuthContext";
import WordLesson from "../Components/WordLesson/WordLesson";
import QuizLesson from "../Components/QuizLesson/QuizLesson";
import TheoryLesson from "../Components/TheoryLesson/TheoryLesson";
import UploadLesson from "../Components/UploadLesson/UploadLesson";
import { useTranslation } from "react-i18next";

function Content() {
  const { lessonId, moduleId, id } = useParams();
  const [lesson, setLesson] = useState(null);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { module } = useModuleContext();
  const { authData } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchLesson = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/lessons/lesson/${lessonId}`
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Une erreur est survenue");
        }

        setLesson(data.lesson);
        console.log(data);
      } catch (err) {
        setError(err.message);
        console.error(err);
      }
    };
    fetchLesson();
  }, [lessonId]);

  if (!lesson) {
    return <div>Loading...</div>;
  }

  if (lesson.type === "PDF") {
    return <PdfLesson lesson={lesson} setLesson={setLesson} />;
  }

  if (lesson.type === "Quiz") {
    return <QuizLesson lesson={lesson} setLesson={setLesson} />;
  }

  if (lesson.type === "Word") {
    return <WordLesson lesson={lesson} setLesson={setLesson} />;
  }

  if (lesson.type === "Theory") {
    return <TheoryLesson lesson={lesson} setLesson={setLesson} />;
  }

  if (lesson.type === "Upload") {
    return <UploadLesson lesson={lesson} setLesson={setLesson} />;
  }

  return (
    <>
      <Container className="p-5 border rounded bg-light text-center">
        <p>{t("lesson_vide")}</p>
      </Container>
    </>
  );
}

export default Content;
